export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14630.ab7786b2.jpg";